export default "__VITE_ASSET__CF_ZjWR3__"